import {Text, Icon} from '@albert-io/atomic';
import classNames from 'classnames';
import React, {useState} from 'react';
import SchoolSearchModal from 'components/SchoolSearchModal/SchoolSearchModal.react';

const SchoolAssociation = ({schoolError, school, isTeacher, onSchoolClick}) => {
  const [showEditSchoolModal, setShowEditSchoolModal] = useState(false);

  const schoolFullAddress = school?.getFullAddress?.();

  return (
    <div className='account-profile__form-row mx-x0 mt-x0 mb-x4 flex'>
      <div className='account-profile__form-col my-x0 ml-x0 flex w-full'>
        <div className='flex grow flex-col'>
          <div className='mx-x0 mt-x0 mb-x1'>
            <Text>School association</Text>
          </div>
          <div
            data-testid='school-association-card'
            className={classNames(
              'flex cursor-pointer items-center justify-between rounded-x1 border border-primary p-x2 hover:bg-background-primary-hover! active:bg-background-primary-pressed!',
              {
                'border-negative!': !!schoolError
              }
            )}
            onClick={() => setShowEditSchoolModal(true)}
            onKeyDown={() => setShowEditSchoolModal(true)}
          >
            <div className='flex flex-col'>
              {school?.getName?.() ? (
                <>
                  <Text className='mb-x1' data-testid='school-name'>
                    {school?.getName()}
                  </Text>
                  {school.getIn(['district', 'name'], '') ? (
                    <Text className='mb-x1'>{school.getIn(['district', 'name'], '')}</Text>
                  ) : null}
                  <Text color='tertiary'>{schoolFullAddress}</Text>
                </>
              ) : (
                <Text>Choose a school...</Text>
              )}
            </div>
            <Icon icon='pencil' iconStyle='regular' />
          </div>
        </div>
      </div>
      {showEditSchoolModal && (
        <SchoolSearchModal
          handleClose={() => setShowEditSchoolModal(false)}
          hasExistingRecord={(schoolId) => {
            // checks if undefined or if it is an empty map
            if (school && school.size > 0) {
              return school.getId() === schoolId;
            }
          }}
          updateUserSchool={onSchoolClick}
          isTeacher={isTeacher}
        />
      )}
    </div>
  );
};

export default SchoolAssociation;
